const calculatePercent = ({
  numerator,
  denominator,
  places = 0,
}: {
  numerator: number;
  denominator: number;
  places?: number;
}) => {
  if (isNaN(denominator)) throw new Error('denominator is not a number');
  if (isNaN(numerator)) throw new Error('numerator is not a number');
  if (denominator <= 0) {
    return 0;
  }
  const precision = Math.pow(10, places);
  return Math.round((numerator / denominator) * 100 * precision) / precision;
};

export { calculatePercent };
